// Industries (sectors) shown under "Browse sectors". Company lists are examples; extend freely.
// Each company is written as "Name|TICKER".
const ind = (name, sector, group, list) => ({
  id: name.toLowerCase().replace(/[^a-z0-9]+/g, "-"),
  name,
  sector,
  group,
  companies: list.map((s) => {
    const [n, t] = s.split("|");
    return { name: n, ticker: t };
  }),
});

export const INDUSTRIES = [
  // Industrials
  ind("Aerospace & Defense", "Industrials", "Capital Goods", [
    "Lockheed Martin|LMT", "RTX|RTX", "Boeing|BA", "General Dynamics|GD", "Northrop Grumman|NOC",
    "L3Harris Technologies|LHX", "TransDigm|TDG", "Howmet Aerospace|HWM", "Textron|TXT", "Huntington Ingalls|HII",
  ]),
  ind("Machinery", "Industrials", "Capital Goods", [
    "Caterpillar|CAT", "Deere & Company|DE", "Parker-Hannifin|PH", "Illinois Tool Works|ITW",
    "Cummins|CMI", "Otis Worldwide|OTIS", "Ingersoll Rand|IR", "Xylem|XYL",
  ]),
  ind("Electrical Equipment", "Industrials", "Capital Goods", [
    "Eaton|ETN", "Emerson Electric|EMR", "Rockwell Automation|ROK", "AMETEK|AME", "Vertiv|VRT", "Hubbell|HUBB",
  ]),
  ind("Building Products", "Industrials", "Capital Goods", [
    "Carrier Global|CARR", "Trane Technologies|TT", "Johnson Controls|JCI", "Lennox International|LII", "Masco|MAS",
  ]),
  ind("Construction & Engineering", "Industrials", "Capital Goods", [
    "Quanta Services|PWR", "EMCOR Group|EME", "Jacobs Solutions|J", "AECOM|ACM", "Fluor|FLR",
  ]),
  ind("Trading Companies & Distributors", "Industrials", "Capital Goods", [
    "Fastenal|FAST", "W.W. Grainger|GWW", "United Rentals|URI", "WESCO International|WCC",
  ]),
  ind("Air Freight & Logistics", "Industrials", "Transportation", [
    "United Parcel Service|UPS", "FedEx|FDX", "C.H. Robinson|CHRW", "Expeditors International|EXPD",
  ]),
  ind("Airlines", "Industrials", "Transportation", [
    "Delta Air Lines|DAL", "United Airlines|UAL", "Southwest Airlines|LUV", "American Airlines|AAL",
  ]),
  ind("Railroads", "Industrials", "Transportation", [
    "Union Pacific|UNP", "CSX|CSX", "Norfolk Southern|NSC",
  ]),

  // Consumer Discretionary
  ind("Automobiles", "Consumer Discretionary", "Automobiles & Components", [
    "Tesla|TSLA", "Ford Motor|F", "General Motors|GM",
  ]),
  ind("Auto Components", "Consumer Discretionary", "Automobiles & Components", [
    "Aptiv|APTV", "BorgWarner|BWA", "Lear|LEA", "Autoliv|ALV", "Gentex|GNTX",
  ]),
  ind("Specialty Retail", "Consumer Discretionary", "Retailing", [
    "Home Depot|HD", "Lowe's|LOW", "TJX Companies|TJX", "Ross Stores|ROST", "O'Reilly Automotive|ORLY", "AutoZone|AZO", "Best Buy|BBY",
  ]),
  ind("Broadline Retail", "Consumer Discretionary", "Retailing", [
    "Amazon|AMZN", "Target|TGT", "Dollar General|DG", "Dollar Tree|DLTR",
  ]),

  // Consumer Staples
  ind("Beverages", "Consumer Staples", "Food, Beverage & Tobacco", [
    "Coca-Cola|KO", "PepsiCo|PEP", "Monster Beverage|MNST", "Keurig Dr Pepper|KDP", "Constellation Brands|STZ",
  ]),
  ind("Food Products", "Consumer Staples", "Food, Beverage & Tobacco", [
    "General Mills|GIS", "Mondelez|MDLZ", "Hershey|HSY", "Kellanova|K", "Tyson Foods|TSN", "Archer-Daniels-Midland|ADM", "Hormel Foods|HRL",
  ]),
  ind("Tobacco", "Consumer Staples", "Food, Beverage & Tobacco", [
    "Philip Morris International|PM", "Altria|MO",
  ]),

  // Financials
  ind("Banks", "Financials", "Banks", [
    "JPMorgan Chase|JPM", "Bank of America|BAC", "Wells Fargo|WFC", "Citigroup|C", "U.S. Bancorp|USB", "PNC Financial|PNC", "Truist Financial|TFC",
  ]),
  ind("Capital Markets", "Financials", "Financial Services", [
    "Goldman Sachs|GS", "Morgan Stanley|MS", "BlackRock|BLK", "Charles Schwab|SCHW", "S&P Global|SPGI", "CME Group|CME", "Intercontinental Exchange|ICE",
  ]),
  ind("Insurance", "Financials", "Insurance", [
    "Berkshire Hathaway|BRK.B", "Progressive|PGR", "Chubb|CB", "American International Group|AIG", "Travelers|TRV", "MetLife|MET", "Aflac|AFL",
  ]),
  ind("Payments", "Financials", "Financial Services", [
    "Visa|V", "Mastercard|MA", "PayPal|PYPL", "Global Payments|GPN",
  ]),

  // Health Care
  ind("Pharmaceuticals", "Health Care", "Pharma, Biotech & Life Sciences", [
    "Eli Lilly|LLY", "Johnson & Johnson|JNJ", "Merck|MRK", "Pfizer|PFE", "Bristol-Myers Squibb|BMY", "Zoetis|ZTS",
  ]),
  ind("Biotechnology", "Health Care", "Pharma, Biotech & Life Sciences", [
    "AbbVie|ABBV", "Amgen|AMGN", "Gilead Sciences|GILD", "Vertex Pharmaceuticals|VRTX", "Regeneron|REGN", "Moderna|MRNA",
  ]),
  ind("Health Care Providers", "Health Care", "Health Care Equipment & Services", [
    "UnitedHealth Group|UNH", "Elevance Health|ELV", "Cigna|CI", "HCA Healthcare|HCA", "CVS Health|CVS", "Humana|HUM",
  ]),
  ind("Medical Devices", "Health Care", "Health Care Equipment & Services", [
    "Medtronic|MDT", "Abbott Laboratories|ABT", "Boston Scientific|BSX", "Stryker|SYK", "Intuitive Surgical|ISRG", "Edwards Lifesciences|EW",
  ]),

  // Information Technology
  ind("Software", "Information Technology", "Software & Services", [
    "Microsoft|MSFT", "Oracle|ORCL", "Salesforce|CRM", "Adobe|ADBE", "Intuit|INTU", "ServiceNow|NOW", "Palantir|PLTR",
  ]),
  ind("Semiconductors", "Information Technology", "Semiconductors", [
    "NVIDIA|NVDA", "Broadcom|AVGO", "AMD|AMD", "Qualcomm|QCOM", "Texas Instruments|TXN", "Micron|MU", "Intel|INTC", "Applied Materials|AMAT",
  ]),
  ind("IT Services", "Information Technology", "Software & Services", [
    "Accenture|ACN", "IBM|IBM", "Cognizant|CTSH", "Gartner|IT", "EPAM Systems|EPAM",
  ]),
  ind("Technology Hardware", "Information Technology", "Technology Hardware", [
    "Apple|AAPL", "Dell Technologies|DELL", "HP Inc.|HPQ", "Cisco|CSCO", "Hewlett Packard Enterprise|HPE",
  ]),

  // Communication Services
  ind("Interactive Media", "Communication Services", "Media & Entertainment", [
    "Alphabet|GOOGL", "Meta Platforms|META", "Pinterest|PINS", "Snap|SNAP", "Reddit|RDDT",
  ]),
  ind("Media & Entertainment", "Communication Services", "Media & Entertainment", [
    "Netflix|NFLX", "Walt Disney|DIS", "Comcast|CMCSA", "Fox Corporation|FOXA", "Live Nation|LYV",
  ]),
  ind("Telecom Services", "Communication Services", "Telecommunication Services", [
    "Verizon|VZ", "AT&T|T", "T-Mobile US|TMUS",
  ]),

  // Energy
  ind("Oil, Gas & Consumable Fuels", "Energy", "Energy", [
    "Exxon Mobil|XOM", "Chevron|CVX", "ConocoPhillips|COP", "EOG Resources|EOG", "Occidental Petroleum|OXY", "Marathon Petroleum|MPC", "Valero Energy|VLO",
  ]),
  ind("Energy Equipment & Services", "Energy", "Energy", [
    "Schlumberger|SLB", "Baker Hughes|BKR", "Halliburton|HAL",
  ]),

  // Utilities, Materials, Real Estate
  ind("Electric Utilities", "Utilities", "Utilities", [
    "NextEra Energy|NEE", "Duke Energy|DUK", "Southern Company|SO", "American Electric Power|AEP", "Exelon|EXC", "Xcel Energy|XEL",
  ]),
  ind("Chemicals", "Materials", "Materials", [
    "Linde|LIN", "Sherwin-Williams|SHW", "Air Products|APD", "Ecolab|ECL", "Dow|DOW", "DuPont|DD",
  ]),
  ind("Metals & Mining", "Materials", "Materials", [
    "Newmont|NEM", "Freeport-McMoRan|FCX", "Nucor|NUE", "Steel Dynamics|STLD", "Southern Copper|SCCO",
  ]),
  ind("Equity REITs", "Real Estate", "Real Estate", [
    "Prologis|PLD", "American Tower|AMT", "Equinix|EQIX", "Realty Income|O", "Simon Property Group|SPG", "Public Storage|PSA",
  ]),
];